// @ts-nocheck
import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Check, RefreshCw, Edit3, Pause, FlaskConical } from 'lucide-react'
import { motion } from 'framer-motion'
import { toast } from 'sonner'

export function HumanReviewCard({ review, onAction }) {
  const [selected, setSelected] = useState('')
  const [comment, setComment] = useState('')
  const [responded, setResponded] = useState(false)

  if (!review) return null

  const handleAction = (action) => {
    setResponded(true)
    onAction?.({ action, selected, comment })
    toast.success(`Action: ${action}`, { description: selected || 'No option selected' })
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      <Card className="border-primary/30 shadow-[0_0_20px_rgba(99,102,241,0.1)]" role="alertdialog" data-testid="human-review-card">
        <CardHeader className="pb-2 pt-4 px-4">
          <CardTitle className="flex items-center gap-2 text-base">
            <FlaskConical className="h-4 w-4 text-primary" />
            Review Required: {review.topic}
          </CardTitle>
        </CardHeader>
        <CardContent className="px-4 pb-4 space-y-4">
          <Separator className="bg-border/50" />
          <p className="text-sm text-muted-foreground">{review.recommendation}</p>

          {!responded ? (
            <>
              <RadioGroup value={selected} onValueChange={setSelected} className="space-y-2.5" data-testid="review-options">
                {review.options?.map((opt) => (
                  <div key={opt.id} className="flex items-center space-x-2">
                    <RadioGroupItem value={opt.id} id={opt.id} data-testid={`review-option-${opt.id}`} />
                    <Label htmlFor={opt.id} className="text-sm cursor-pointer leading-snug">{opt.label}</Label>
                  </div>
                ))}
              </RadioGroup>

              <textarea
                placeholder="Optional comment..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full min-h-[60px] text-sm p-2 rounded-md border border-border bg-background resize-none outline-none focus:ring-1 focus:ring-primary/30"
                data-testid="review-comment"
              />

              <div className="flex flex-wrap gap-2">
                <Button size="sm" className="rounded-full" onClick={() => handleAction('approve')} disabled={!selected} data-testid="review-approve-btn">
                  <Check className="h-3.5 w-3.5 mr-1.5" /> Approve
                </Button>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => handleAction('alternative')} data-testid="review-alternative-btn">
                  <RefreshCw className="h-3.5 w-3.5 mr-1.5" /> Try Alternative
                </Button>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => handleAction('modify')} data-testid="review-modify-btn">
                  <Edit3 className="h-3.5 w-3.5 mr-1.5" /> Modify
                </Button>
                <Button size="sm" variant="ghost" className="rounded-full" onClick={() => handleAction('pause')} data-testid="review-pause-btn">
                  <Pause className="h-3.5 w-3.5 mr-1.5" /> Pause
                </Button>
              </div>
            </>
          ) : (
            <div className="text-sm text-muted-foreground italic" data-testid="review-responded">
              Response submitted. Continuing analysis...
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  )
}
